var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('nav', {
    staticClass: "tabs"
  }, [_c('ul', _vm._l(_vm.titles, function (title) {
    return _c('li', {
      key: title,
      class: {
        on: title == _vm.value
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "height": "4rem"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('input', title);
        }
      }
    }, [_vm._v(_vm._s(title))])], 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }